import andes1280 from 'assets/heroes/andes-1280.webp';
import andes2560 from 'assets/heroes/andes-2560.webp';
import puente from 'assets/heroes/puente-1199.webp';
import ruta1280 from 'assets/heroes/ruta-1280.webp';
import ruta2560 from 'assets/heroes/ruta-2560.webp';

/** A cover photo for `<img src srcSet>`. */
export interface HeroImage {
  src: string;
  srcSet: string;
}

const responsive = (small: string, large: string): HeroImage => ({
  src: small,
  srcSet: `${small} 1280w, ${large} 2560w`
});

export const HERO_PLAN_MAESTRO: HeroImage = responsive(andes1280, andes2560);
export const HERO_ACTIONS: HeroImage = responsive(ruta1280, ruta2560);

// By the Fuente's Spanish name (`name_es` in /api/sources). The other Fuentes' photos come with D6.
const HERO_BY_SOURCE: Record<string, HeroImage> = {
  'Infraestructura física y digital': { src: puente, srcSet: `${puente} 1199w` }
};

/** The cover photo of a Fuente's Home tab; a Fuente without one gets the Plan Maestro photo. */
export const heroImageForSource = (nameEs?: string | null): HeroImage =>
  (nameEs && HERO_BY_SOURCE[nameEs]) || HERO_PLAN_MAESTRO;
